import { Slider as MSlider, SliderProps } from '@mui/material'

export const Slider: React.FC<SliderProps> = (props) => {
  return <MSlider {...props} />
}
